module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"View","list":"List","table":"Table"},"de":{"label":"Ansicht","list":"Liste","table":"Tabelle"}}')
  delete Component.options._Ctor
}
